// extracted by mini-css-extract-plugin
export default {"container":"priceTimer-module__container__COsps","icon":"priceTimer-module__icon__IVjg6","loader":"priceTimer-module__loader__oi+Qr","text":"priceTimer-module__text__9a+6m"};